import React from 'react';
import { connect } from 'react-redux';

import TableWidgetResourceLibrary from 'cyder/table/TableWidgetResourceLibrary';

const MemberResourcesPastEvents = ({ pastEvents }) => <TableWidgetResourceLibrary items={pastEvents} />;

export default MemberResourcesPastEvents;
